import React from 'react';
import styled from 'styled-components';
import { STATUS } from '../Toastify/Notify';
import AppModal from './AppModal';
import iconErr from 'assets/icons/error.svg';
import iconSuccess from 'assets/icons/checked.svg';
import { iconInfo2 } from 'assets/icons';
import ButtonGradient from '../Button/ButtonGradient';

const AppModalStyled = styled(AppModal)`
	.ant-modal-content {
		.ant-modal-header {
			border-bottom: 1px solid #eeeeee;
			padding-bottom: 12px;
		}
	}
`;
export default function ModalNotify({
	afterClose,
	isShow,
	onClose,
	content,
	className,
	type,
	isShowClose = true,
	callBack,
	...props
}) {
	const getIconNoti = () => {
		if (type === STATUS.err) {
			return iconErr;
		} else if (type === STATUS.success) {
			return iconSuccess;
		} else if (type === STATUS.info) {
			return iconInfo2;
		}
	};

	const closeModal = () => {
		afterClose && afterClose();
		onClose && onClose();
	};

	return (
		<AppModalStyled
			{...props}
			title={null}
			footer={null}
			centered={true}
			visible={isShow}
			width={400}
			onCancel={closeModal}
			maskClosable={false}
			closable={false}
		>
			<div className='mt-30px flex flex-col items-center'>
				<img src={getIconNoti()} width={48} height={48} alt='' />
				<div className='mt-8px text-14px flex-1 w-full text-center'>
					{content}
				</div>
				{isShowClose && (
					<ButtonGradient
						className='py-12px md:w-155px flex-grow md:flex-grow-0 mt-16px'
						type='text'
						onClick={closeModal}
					>
						ĐÓNG
					</ButtonGradient>
				)}
			</div>
		</AppModalStyled>
	);
}
